"use client";

import { useState } from "react";
import { cn } from "@/lib/utils";

export interface MegaMenuGroup {
	trigger: React.ReactNode;
	panel?: React.ReactNode;
}

interface MegaMenuClientProps {
	groups: MegaMenuGroup[];
}

export function MegaMenuClient({ groups }: MegaMenuClientProps) {
	const [active, setActive] = useState(groups.findIndex((group) => group.panel));

	return (
		<div className="flex flex-col gap-(--ms-card-padding-left) md:flex-row">
			{groups.length > 1 && (
				<div className="flex shrink-0 flex-col gap-[calc(var(--ms-card-padding-top)/2)] border-b border-(--ms-card-border-color) pb-(--ms-card-padding-bottom) md:w-52 md:border-r md:border-b-0 md:pr-(--ms-card-padding-right) md:pb-0">
					{groups.map((group, index) => (
						<div
							key={index}
							onMouseEnter={group.panel ? () => setActive(index) : undefined}
							onFocus={group.panel ? () => setActive(index) : undefined}
							className={cn(
								"flex items-center justify-between gap-[calc(var(--ms-card-padding-left)/2)] rounded-(--ms-card-border-bottom-left-radius)",
								index === active && "text-(--link-hover-color)",
							)}
						>
							{group.trigger}
						</div>
					))}
				</div>
			)}

			<div className="grid min-w-0 flex-1">
				{groups.map(
					(group, index) =>
						group.panel && (
							<div key={index} className={cn("col-start-1 row-start-1 flex", index !== active && "invisible")}>
								{group.panel}
							</div>
						),
				)}
			</div>
		</div>
	);
}
